export default __webpack_public_path__ + "static/media/Accelerons2013.8d0df77a.png";